import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatTheDuckHero from './components/WhatTheDuckHero';
import HowItWorks from './components/HowItWorks';
import DuckGallery from './components/DuckGallery';
import DuckMap from './components/DuckMap';
import ShareBanner from './components/ShareBanner';
import SubmitDuckForm from './components/SubmitDuckForm';
import KeepExploring from '../../components/feature/KeepExploring';
import SEO from '../../components/feature/SEO';

export default function WhatTheDuck() {
  const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'What the Duck — Gwinnett Community Scavenger Hunt | The Mommy Mingle',
    description:
      'Join the What the Duck community scavenger hunt in Gwinnett County. Find hidden ducks, share your finds, and connect with local families.',
    url: `${siteUrl}/whattheduck`,
    publisher: {
      '@type': 'Organization',
      name: 'The Mommy Mingle',
      url: siteUrl,
    },
    mainEntity: {
      '@type': 'Event',
      name: 'What the Duck Scavenger Hunt',
      description:
        'Community scavenger hunt where families find and share hidden rubber ducks across Gwinnett County, Georgia.',
      location: {
        '@type': 'Place',
        name: 'Gwinnett County, Georgia',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Gwinnett County',
          addressRegion: 'GA',
          addressCountry: 'US',
        },
      },
      organizer: {
        '@type': 'Organization',
        name: 'The Mommy Mingle',
        url: siteUrl,
      },
    },
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="What the Duck — Gwinnett Community Scavenger Hunt | The Mommy Mingle"
        description="Join the What the Duck scavenger hunt in Gwinnett County. Find hidden ducks, share your finds, and connect with local families in a fun community game."
        keywords="What the Duck Gwinnett, community scavenger hunt Georgia, family activities Gwinnett County, rubber duck hunt"
        canonical="/whattheduck"
        schema={schema}
      />
      <Navbar />
      <WhatTheDuckHero />
      <HowItWorks />
      <DuckGallery />
      <DuckMap />
      <ShareBanner />
      <SubmitDuckForm />
      <KeepExploring
        title="Keep Exploring"
        subtitle="More fun things waiting for your family across Gwinnett and Sugar Hill."
        items={[
          { label: 'See Local Events', icon: 'ri-calendar-event-line', to: '/events' },
          { label: 'Explore Things To Do', icon: 'ri-map-pin-2-line', to: '/things-to-do' },
          { label: 'Join The Mommy Mingle', icon: 'ri-group-line', href: 'https://www.facebook.com/groups/themommymingle', primary: true },
        ]}
      />
      <Footer />
    </div>
  );
}
